import axios from 'axios';

import { parseResponse, handleError } from '@/_helpers/utils.js';

const state = {
  // when you edit this, pay attention on reset mutation
  loading: true,
  error: null,
  companies: [],
  company_list: [],
  stage_list: [],
  company: null,
  pagination: {
    pageNumber: 1,
    totalPages: 1,
    load_more_pages: 1,
    is_load_more: false,
    total: 20,
    count: 20
  },
  filters: {
    search_term: '',
    company_id: '',
    domain_prefix: '',
    employee_email: '',
    created_from: '',
    created_to: '',
    personal_manager_id: [],
    geo: {}
  },
  sorting: {
    name: null,
    order: 'asc'
  }
};

const actions = {
  fetch({ commit, state, dispatch }, model) {
    commit('fetch');

    let params = model || {};

    params.page = state.pagination.pageNumber;
    params.count = state.pagination.count;

    const sorting = state.sorting;

    if (sorting.name) {
      Object.assign(params, {
        sort_by: sorting.name,
        sort_order: sorting.order
      });
    }

    Object.keys(state.filters).forEach(key => {
      if (state.filters[key] && key !== 'geo') {
        Object.assign(params, {
          [key]: state.filters[key]
        });
      }
    });

    /* if (state.filters.search_term) {
      Object.assign(params, {
        search_term: state.filters.search_term
      })
    } */

    if (state.filters.geo && state.filters.geo.place_id) {
      Object.assign(params, {
        geo: state.filters.geo.place_id
      });
    }

    return axios
      .get('/1.0/admin/companies', { params })
      .then(response => {
        const data = parseResponse(response);
        commit('fetchSuccess', { data: data.data, meta: data.meta });
      })
      .catch(err => {
        const error = handleError(err);

        dispatch('global/setError', error, { root: true });
        commit('fetchFailure', error);
      });
  },

  fetch_more({ commit, state, dispatch }, model) {
    commit('fetch');

    const count = state.pagination.pageNumber * state.companies.length + state.pagination.count;

    let params = model || {};

    params.page = 1;
    params.count = count;

    const sorting = state.sorting;

    if (sorting.name) {
      Object.assign(params, {
        sort_by: sorting.name,
        sort_order: sorting.order
      });
    }

    return axios
      .get('/1.0/admin/companies', { params })
      .then(response => {
        const data = parseResponse(response);
        commit('fetch_more_success', { data: data.data, meta: data.meta });
        commit('set_pagination_more', { count });
      })
      .catch(err => {
        const error = handleError(err);

        dispatch('global/setError', error, { root: true });
        commit('fetchFailure', error);
      });
  },

  fetch_company_list({ commit, state, dispatch }, data = {}) {
    commit('fetch');

    const count = 100;

    let params = {};

    params.page = data.page !== undefined ? data.page : 1;
    params.count = data.count !== undefined ? data.count : count;

    return axios
      .get('/1.0/admin/companies-names', { params })
      .then(response => {
        const data = parseResponse(response);

        commit('fetch_company_list_success', { data: data.data, meta: data.meta });
      })
      .catch(err => {
        const error = handleError(err);

        dispatch('global/setError', error, { root: true });
        commit('fetchFailure', error);
      });
  },

  fetch_stage_list({ commit, state, dispatch }) {
    commit('fetch');

    const count = 100;

    let params = {};

    params.page = 1;
    params.count = count;

    return axios
      .get('/1.0/response-stages', { params })
      .then(response => {
        const data = parseResponse(response);

        commit('fetch_stage_list_success', { data: data.data, meta: data.meta });
      })
      .catch(err => {
        const error = handleError(err);

        dispatch('global/setError', error, { root: true });
        commit('fetchFailure', error);
      });
  },

  updateSorting({ commit, state, dispatch }, data) {
    commit('updateSorting', data);
    dispatch('fetch');
  },

  updateFilters({ commit, state, dispatch }, data) {
    commit('resetPagination');
    commit('updateFilters', data);
  }
};

const mutations = {
  fetch(state) {
    state.loading = true;
  },

  fetchSuccess(state, { data, meta }) {
    state.pagination.total = meta.total;
    state.pagination.totalPages = Math.ceil(meta.total / state.pagination.count);
    state.companies = data;
    state.loading = false;
  },

  fetch_more_success(state, { data, meta }) {
    state.companies = data;
    state.loading = false;
  },

  fetch_company_list_success(state, { data, meta }) {
    state.company_list = data;
    state.loading = false;
  },

  fetch_stage_list_success(state, { data, meta }) {
    state.stage_list = data;
    state.loading = false;
  },

  set_pagination_more(state, { count }) {
    state.pagination.load_more_pages = Math.ceil(count / state.pagination.count);
  },

  fetchFailure(state, err) {
    state.error = err;
    state.loading = false;
    console.error(err);
  },

  updatePagination(state, params) {
    state.pagination = Object.assign(state.pagination, params);
  },

  resetPagination(state) {
    state.pagination = Object.assign({}, state.pagination, {
      pageNumber: 1,
      totalPages: 1,
      load_more_pages: 1,
      is_load_more: false,
      count: 20
    });
  },

  change_count(state, val) {
    state.pagination = Object.assign(state.pagination, {
      count: val
    });
  },

  updateSorting(state, data) {
    Object.assign(state.sorting, data);
  },

  store(state) {
    state.loading = true;
  },

  updateFilters(state, data) {
    const filters = state.filters;

    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined) {
        Object.assign(filters, {
          [key]: data[key] || ''
        });
      }
    });

    if (data.geo) {
      Object.assign(filters, {
        geo: data.geo || {}
      });
    }
  }
};

const getters = {
  loading: state => {
    return state.loading;
  },

  list: state => {
    return state.companies;
  },

  company_list: state => {
    return state.company_list;
  },

  stage_list: state => {
    return state.stage_list;
  },

  filters: state => {
    return state.filters;
  },

  pagination: state => {
    return state.pagination;
  },

  sorting: state => {
    return state.sorting;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
